module.exports = __webpack_public_path__ + "static/media/cancel.44719bfa.svg";